module.exports = __webpack_public_path__ + "static/media/cq_tutti b.38f78efe.svg";